// The API is served under /api on the same origin as the app (see deploy/local/nginx.conf).
// For `parcel` development against a separately started backend, set API_URL, e.g. API_URL=http://localhost:5000/api.
export const getAPIURL = (isWebsocket: boolean = false) => {
  const apiURL = process.env.API_URL || `${window.location.origin}/api`;

  return isWebsocket ? apiURL.replace(/^http/, 'ws') : apiURL;
};
